import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.NumberPicker = function (element) {
        this.$numberPicker = $(element);
        this.$minusButton = $('.onIconMinus', this.$numberPicker);
        this.$plusButton = $('.onIconPlus', this.$numberPicker);
        this.$pickerValue = $('.count input', this.$numberPicker);
        this.$input = $('input', this.$numberPicker);
        this.value = parseInt(this.$numberPicker.data('init-val'));
        this.minVal = parseInt(this.$numberPicker.data('min'));
        this.maxVal = parseInt(this.$numberPicker.data('max'));

        this.init();
    };

    OndigoNS.NumberPicker.prototype = {
        init: function () {
            var _scope = this;

            _scope.handlePicker();

            this.$numberPicker.addClass('initialized');
            this.$input.attr('min', this.minVal);
            this.$input.attr('max', this.maxVal);

            this.$plusButton.on('click', function() {
                if (!$(this).hasClass('deactivated')) {
                    _scope.value++;
                    _scope.handlePicker();
                }
            });
            this.$minusButton.on('click', function() {
                if (!$(this).hasClass('deactivated')) {
                    _scope.value--;
                    _scope.handlePicker();
                }
            });
            this.$input.on('input keyup', function() {
                _scope.value = _scope.checkIfLegalNumber($(this).val(), parseInt($(this).attr('max')), parseInt($(this).attr('min')));
                $(this).val(_scope.value);
                _scope.checkForDeactivation();
            });
        },
        checkIfLegalNumber : function (value, maxValue, minValue) {
            var numberLength = maxValue.length;

            if (!minValue) {
                minValue = 1;
            }

            if (value.length > numberLength)
                value = value.slice(0,numberLength);

            // this looks like nonsense, but is important. Characters are empty strings in a number-field
            if (value === '') {
                value = '';
            }
            else if (value< minValue){
                value = minValue;
            }
            else if (!$.isNumeric(value)){
                value = minValue;
            }
            else if (parseInt(value) > parseInt(maxValue)) {
                value = maxValue;
            }
            return value;
        },
        checkForDeactivation: function() {
            if (this.value >= this.maxVal) {
                this.$plusButton.addClass('deactivated');
                this.$minusButton.removeClass('deactivated');
            }
            else if (this.value <= this.minVal) {
                this.$minusButton.addClass('deactivated');
                this.$plusButton.removeClass('deactivated');
            }
            else {
                this.$minusButton.removeClass('deactivated');
                this.$plusButton.removeClass('deactivated');
            }
        },
        reactivatePlus: function() {
            $.each($('.numberPicker'), function() {
                if (parseInt($(this).data('max')) !==  parseInt($('.count', $(this)).text())) {
                    $('.onIconPlus', $(this)).removeClass('deactivated');
                }
            });
            $('.button.next').removeClass('visible');
        },
        handlePicker: function() {
            this.updatePicker();
            this.checkForDeactivation();
        },
        updatePicker: function() {
            var _scope = this;
            this.$pickerValue.val(this.value);

            window.setTimeout(function() {
                _scope.checkForNewNumberPickers();
            }, 200);
        },
        checkForNewNumberPickers: function() {
            var $numberPicker = $('.numberPicker');
            if ($numberPicker.length) {
                $.each($numberPicker, function () {
                    if (!$(this).hasClass('initialized')) {
                        $(this).numberPicker();
                    }
                });
            }
        }
    };
    // plugin definition
    $.fn.numberPicker = function () {
        return new OndigoNS.NumberPicker(this);
    };
    $.fn.numberPicker.Constructor = OndigoNS.NumberPicker;

}(window.jQuery));

$(document).ready(function () {
    'use strict';

    var $numberPicker = $('.numberPicker');
    if ($numberPicker.length) {
        $.each($numberPicker, function () {
            if (!$(this).hasClass('initialized')) {
                $(this).numberPicker();
            }
        });
    }
});